import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconChat = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 56.7 56.7"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <path
            d="M38.2943,20.5751c-4.5718,0.2388-8.5473,1.6248-11.7749,4.7559c-3.261,3.1634-4.7496,7.0398-4.3427,11.8451   c-1.7869-0.2213-3.4145-0.4649-5.0514-0.6027c-0.5653-0.0476-1.2362,0.02-1.715,0.2902c-1.5894,0.8969-3.1132,1.9095-4.9192,3.0384   c0.3314-1.4988,0.5459-2.8113,0.9256-4.0737c0.2793-0.9278,0.1499-1.4442-0.7048-2.0485   c-5.4881-3.8747-7.8014-9.6734-6.0702-15.6433c1.6017-5.5228,5.5351-8.8722,10.8797-10.6182   c7.2949-2.3828,15.493,0.0478,19.9288,5.8395C37.0523,15.4499,38.0347,17.798,38.2943,20.5751z M17.2534,18.7149   c0.0421-1.0919-0.904-2.0756-2.0279-2.1085c-1.1506-0.0338-2.097,0.8455-2.1306,1.9793c-0.034,1.1491,0.8449,2.07,2.0039,2.0994   C16.2478,20.7143,17.2109,19.8338,17.2534,18.7149z M28.2313,16.6057c-1.128,0.0208-2.0811,0.9815-2.0611,2.0777   c0.0206,1.1363,0.9556,2.0252,2.1155,2.0113c1.1629-0.014,2.0449-0.9124,2.0339-2.0726   C30.3099,17.4831,29.3791,16.5847,28.2313,16.6057z"
            fill="currentColor"/>
        <path
            d="M48.5655,49.0767c-1.4476-0.6446-2.7756-1.6117-4.1894-1.7594c-1.4084-0.1471-2.8889,0.6654-4.3624,0.8161   c-4.4883,0.4592-8.5093-0.7917-11.8249-3.8579C21.8829,38.443,22.784,29.5,30.0796,24.7203   c6.4841-4.248,15.9934-2.8318,20.5649,3.0624c3.9895,5.1433,3.5206,11.9709-1.3497,16.2917   c-1.4093,1.2505-1.9165,2.2796-1.0122,3.9281C48.4495,48.3069,48.4686,48.6923,48.5655,49.0767z M32.0869,33.122   c0.9216,0.0009,1.6805-0.7203,1.7154-1.6306c0.0368-0.9637-0.7383-1.772-1.7033-1.776c-0.9554-0.0043-1.7558,0.8153-1.7226,1.7647   C30.4077,32.3872,31.1719,33.1209,32.0869,33.122z M42.7098,29.7192c-0.8942-0.0062-1.654,0.7258-1.6905,1.6293   c-0.0387,0.9662,0.7122,1.7596,1.6684,1.762c0.9248,0.003,1.6555-0.6964,1.6891-1.6166   C44.4127,30.5255,43.6614,29.7258,42.7098,29.7192z"
            fill="currentColor"/>
      </svg>
  )
}

TLIconChat.defaultProps = {
  className: '',
  height: 24,
  width: 24,
  tooltip: null
}
